import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** picture, image. Decorative line icon; always pair with a visible text label. */
export function ImageIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="3.5" y="5" width="17" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.4" />
      <path d="M4.5 16.5l4-4 3 3 4.5-4.5 4 4" />
    </IconSvg>
  )
}
